// true en celulares y tablets (navegador o la app de Android), sin importar el
// ancho de pantalla: la cámara para sacar fotos se ofrece siempre en estos
// dispositivos y nunca en una computadora, aunque la ventana sea angosta.
// La app de Android es un WebView que expone window.Android (ver GoogleAd.js).
export const isMobileDevice = () => {
  if (typeof window === "undefined") return false;
  if (typeof window.Android !== "undefined") return true;
  const ua = navigator.userAgent || "";
  if (/Android|iPhone|iPad|iPod|Mobile/i.test(ua)) return true;
  // iPadOS se presenta como "Macintosh" pero tiene pantalla táctil.
  return /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
};

// App de iOS (AppStore/ en el repo): un WKWebView que suma "NotilineiOS/x" al
// user agent. Ahí no se ofrece el login con Google (Google lo bloquea dentro
// de un WebView) ni la compra de planes, destacados o tiendas (Apple exige su
// propio sistema de pagos para lo digital).
export const isIOSApp = () =>
  typeof navigator !== "undefined" && /NotilineiOS\//.test(navigator.userAgent || "");
